import { GridSpacing } from '@mui/material';
import LangEnum from '../../lang/LangEnum';
import { AddressFormValues, AddressValues } from './address.schema';
import { AddressTypeEnum } from './adress.enum';

export interface AddressProps {
  name?: string;
  disabled?: boolean;
  complementDisabled?: boolean;
  spacing?: GridSpacing;
  columnSpacing?: GridSpacing;
  rowSpacing?: GridSpacing;
  hiddenFields?: string[];
}

export type AddressSubmitStatus = 'edit' | 'success' | 'error';

export interface AddressFormHandle {
  submit: (values: AddressFormValues) => Promise<AddressSubmitStatus>;
}

export interface AddressFormItem {
  principal?: boolean;
  address?: Partial<AddressValues> & Record<string, unknown>;
}

export const addressTypes: Array<{ value: AddressTypeEnum; label: string }> = [
  {
    value: AddressTypeEnum.DELIVERY,
    label: LangEnum.ADDRESS_TYPE_DELIVERY,
  },
  {
    value: AddressTypeEnum.BILLING,
    label: LangEnum.ADDRESS_TYPE_BILLING,
  },
  {
    value: AddressTypeEnum.COMMERCIAL,
    label: LangEnum.ADDRESS_TYPE_COMMERCIAL,
  },
];
